import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Auth SEAM — provider-shaped (ADR-079 core layer; architect ruling 2026-07-09).
 *
 * app-core abstracts "acquire + hold a session"; each SHELL plugs its own
 * provider and passes the resulting `Auth` in:
 *  - web-ui / desktop → an OIDC provider (Zitadel authorization_code + PKCE) —
 *    lands when the browser OIDC client is provisioned (ADR-012 Q2, gap G).
 *  - mini-app → an initData-exchange provider (POST raw Telegram initData →
 *    gateway initData→session endpoint → hold the session) — impl lands with
 *    ADR-082 + the gateway unit-3 endpoint.
 *
 * The SESSION-TOKEN SHAPE is deliberately opaque to app-core: `getAccessToken`
 * is the common bearer case (OIDC + an initData→JWT exchange both return a
 * bearer). If ADR-082 rules a non-bearer session (Set-Cookie / opaque id), that
 * is absorbed by the shell's provider + its transport wiring — NOT here.
 * `createMockAuth` is the zero-backend default every shell can fall back to.
 */
import { createContext, useContext } from 'react';
const AuthContext = createContext(null);
/** Zero-backend demo session — the default until a shell plugs a real provider. */
export function createMockAuth() {
    return {
        status: 'authenticated',
        user: { name: 'Демо-пользователь' },
        getAccessToken: async () => null,
        login: () => undefined,
        logout: () => {
            // mock logout is a no-op reload — keeps the demo loop simple
            window.location.reload();
        },
    };
}
/** Generic provider — the shell builds the `Auth` impl and injects it. */
export function AuthProvider({ auth, children }) {
    return _jsx(AuthContext.Provider, { value: auth, children: children });
}
export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx)
        throw new Error('useAuth outside <AuthProvider>');
    return ctx;
}
//# sourceMappingURL=AuthProvider.js.map